import { useQuery } from "@tanstack/react-query";
import { RoleShell, type RoleShellNavItem } from "./RoleShell";
import { companyApi } from "../lib/api";
import { isCompanyAdmin, orgIsVerified, orgKycNavLabel } from "../lib/companyKyc";
import { NAV_COPY, NAV_ICONS } from "../lib/navCopy";

const NAV_SECTIONS = [
  {
    label: NAV_COPY.sections.marketplace,
    items: [{ to: "/consultancy/jobs", label: NAV_COPY.common.openJobs, icon: NAV_ICONS.openJobs }],
  },
  {
    label: NAV_COPY.sections.pipeline,
    items: [
      { to: "/consultancy/candidates", label: NAV_COPY.common.candidates, icon: NAV_ICONS.candidates },
      { to: "/consultancy/submissions", label: NAV_COPY.common.submissions, icon: NAV_ICONS.submissions },
    ],
  },
  {
    label: NAV_COPY.sections.team,
    items: [
      { to: "/consultancy/recruiters", label: NAV_COPY.consultancy.recruiters, icon: NAV_ICONS.recruiters },
      { to: "/consultancy/team", label: NAV_COPY.consultancy.admins, icon: NAV_ICONS.consultancyAdmins },
    ],
  },
  {
    label: NAV_COPY.sections.finance,
    items: [
      { to: "/consultancy/payments", label: NAV_COPY.common.payments, icon: NAV_ICONS.payments },
      { to: "/consultancy/rate-card", label: NAV_COPY.common.rateCard, icon: NAV_ICONS.rateCard },
    ],
  },
];

export function ConsultancyLayout() {
  const companyQuery = useQuery({ queryKey: ["my-company"], queryFn: companyApi.myCompany });
  const overviewItems: RoleShellNavItem[] = [
    { to: "/consultancy", label: NAV_COPY.common.dashboard, icon: NAV_ICONS.dashboard, end: true },
  ];
  if (
    isCompanyAdmin(companyQuery.data) &&
    !orgIsVerified(companyQuery.data?.verification_status)
  ) {
    overviewItems.push({
      to: "/consultancy/kyc",
      label: orgKycNavLabel(companyQuery.data?.verification_status),
      icon: NAV_ICONS.orgKyc,
    });
  }

  const navSections = [{ label: NAV_COPY.sections.overview, items: overviewItems }, ...NAV_SECTIONS];

  return (
    <RoleShell
      portalLabel="Consultancy Portal"
      logoTo="/consultancy"
      navSections={navSections}
      avatarFallback="C"
      profileTo="/consultancy/profile"
    />
  );
}
